module.exports = __webpack_public_path__ + "img/blanket_drawed.d1bb34fa.png";